export default __webpack_public_path__ + "static/media/ai.1d586b8f.svg";